(function () {
  const form = document.querySelector('[data-js-bread-order-form]');
  const footer = document.querySelector('[data-js-order-footer]');
  const addAllBtn = document.querySelector('[data-js-add-all-btn]');
  const footerCount = document.querySelector('[data-js-footer-count]');
  const footerTotal = document.querySelector('[data-js-footer-total]');

  if (!form) return;

  const confirmModal = document.getElementById('cart-clear-confirm-modal');
  if (confirmModal && confirmModal.parentElement !== document.body) document.body.append(confirmModal);
  const confirmMessage = confirmModal && confirmModal.querySelector('[data-js-confirm-message]');
  const confirmBtn = confirmModal && confirmModal.querySelector('[data-js-confirm]');

  const requestCartClearConfirmation = (itemCount) => {
    return new Promise((resolve) => {
      if (!confirmModal) { resolve(true); return; }
      const word = itemCount === 1 ? 'item' : 'items';
      confirmMessage.textContent =
        'Changing the delivery day will clear the ' + itemCount + ' ' + word + ' in your cart.';
      var settled = false;
      var settle = function (result) {
        if (settled) return;
        settled = true;
        observer.disconnect();
        resolve(result);
      };
      confirmBtn.addEventListener('click', function () {
        confirmModal.hide();
        settle(true);
      }, { once: true });
      var observer = new MutationObserver(function () {
        if (!confirmModal.classList.contains('active')) settle(false);
      });
      observer.observe(confirmModal, { attributes: true, attributeFilter: ['class'] });
      confirmModal.show();
    });
  };

  // ── Utilities ────────────────────────────────────────────────────────────────

  const waitForFilter = (cb, attempts) => {
    attempts = attempts || 0;
    if (window.InventoryFilter) { cb(); return; }
    if (attempts > 50) return;
    setTimeout(() => waitForFilter(cb, attempts + 1), 100);
  };

  const toMiamiDate = (offsetDays) => {
    const now = new Date();
    const miami = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    miami.setDate(miami.getDate() + (offsetDays || 0));
    const pad = (n) => String(n).padStart(2, '0');
    return `${miami.getFullYear()}-${pad(miami.getMonth() + 1)}-${pad(miami.getDate())}`;
  };

  const resolveDate = (date) => {
    if (date === 'today') return toMiamiDate(0);
    if (date === 'tomorrow') return toMiamiDate(1);
    return date;
  };

  // Maps a stored ISO date back to 'today' or 'tomorrow'. Stale or unrecognized → 'today'.
  const resolveDateLabel = (isoDate) => {
    if (isoDate === toMiamiDate(0)) return 'today';
    if (isoDate === toMiamiDate(1)) return 'tomorrow';
    return 'today';
  };

  const loadConfig = () => {
    try {
      const raw = JSON.parse(localStorage.getItem('domaselo_delivery_config'));
      if (!raw) return null;
      const todayIso = toMiamiDate(0);
      const d = raw.date;
      // Normalize legacy symbolic strings and stale past dates → today
      if (!d || d === 'today' || d === 'tomorrow' || d < todayIso) {
        const normalized = Object.assign({}, raw, { date: todayIso });
        delete normalized.autoSwitchedFromToday;
        try { localStorage.setItem('domaselo_delivery_config', JSON.stringify(normalized)); } catch (_) {}
        return normalized;
      }
      return raw;
    } catch (_) { return null; }
  };

  const formatMoney = (cents) =>
    (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

  const getRows = () => [...form.querySelectorAll('[data-js-order-row]')];

  // ── Twin rows ────────────────────────────────────────────────────────────────
  // The same product can be listed in more than one collection — a spotlight item
  // that also lives in Spreads. Those rows are the same product, so they have to
  // move together, and the order has to count them only once.

  const rowsForProduct = (productId) =>
    [...form.querySelectorAll(`[data-js-order-row][data-product-id="${productId}"]`)];

  const twinRows = (row) => rowsForProduct(row.dataset.productId);

  const uniqueRows = () => {
    const seen = new Set();
    return getRows().filter((row) => {
      if (seen.has(row.dataset.productId)) return false;
      seen.add(row.dataset.productId);
      return true;
    });
  };

  const getQty = (row) => parseInt(row.querySelector('[data-js-qty-input]').value, 10) || 0;

  const setQty = (row, qty) => {
    twinRows(row).forEach((twin) => {
      twin.querySelector('[data-js-qty-input]').value = qty;
      twin.querySelector('[data-js-qty-minus]').disabled = qty <= 0;
    });
  };

  // ── Pending selection persistence ────────────────────────────────────────────

  const SELECTION_KEY = 'domaselo_pending_selection';

  const saveSelection = () => {
    const config = loadConfig();
    if (!config) return;
    const items = [];
    uniqueRows().forEach((row) => {
      const qty = getQty(row);
      if (qty > 0) items.push({ productId: row.dataset.productId, variantId: row.dataset.variantId, qty });
    });
    if (items.length === 0) {
      sessionStorage.removeItem(SELECTION_KEY);
    } else {
      sessionStorage.setItem(SELECTION_KEY, JSON.stringify({
        locationId: config.locationId,
        date: config.date,
        items,
      }));
    }
  };

  const restoreSelection = () => {
    const config = loadConfig();
    if (!config) return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(SELECTION_KEY)); } catch (_) { return; }
    if (!saved || saved.locationId !== config.locationId || saved.date !== config.date) return;

    saved.items.forEach(({ productId, variantId, qty }) => {
      const [row] = rowsForProduct(productId);
      if (!row) return;
      const plus = row.querySelector('[data-js-qty-plus]');
      if (plus.disabled) return; // sold out — don't restore
      // Restore variant if needed (mirrors to the twin rows on its own)
      const pill = row.querySelector(`.variant-pill[data-variant-id="${variantId}"]`);
      if (pill && !pill.classList.contains('variant-pill--active')) pill.click();
      // Restore quantity on every row for this product
      setQty(row, qty);
    });
    updateFooter();
  };

  const clearSelection = () => sessionStorage.removeItem(SELECTION_KEY);

  // ── Footer ───────────────────────────────────────────────────────────────────

  const updateFooter = () => {
    let totalItems = 0;
    let totalCents = 0;

    // Every row gets the highlight, but each product is only counted once.
    getRows().forEach((row) => {
      row.classList.toggle('bread-order-row--selected', getQty(row) > 0);
    });

    uniqueRows().forEach((row) => {
      const qty = getQty(row);
      if (qty > 0) {
        totalItems += qty;
        totalCents += parseInt(row.dataset.variantPrice || '0', 10) * qty;
      }
    });

    if (totalItems > 0) {
      footerCount.textContent = `${totalItems} item${totalItems !== 1 ? 's' : ''} selected`;
      footerTotal.textContent = formatMoney(totalCents);
      footer.style.display = 'flex';
      addAllBtn.disabled = false;
    } else {
      footerCount.textContent = '';
      footerTotal.textContent = '';
      footer.style.display = 'none';
      addAllBtn.disabled = true;
    }
  };

  // ── Row availability ─────────────────────────────────────────────────────────

  const setRowEnabled = (row, enabled) => {
    const plus = row.querySelector('[data-js-qty-plus]');
    const minus = row.querySelector('[data-js-qty-minus]');
    const input = row.querySelector('[data-js-qty-input]');

    if (enabled) {
      plus.disabled = false;
    } else {
      plus.disabled = true;
      minus.disabled = true;
      input.value = '0';
      row.classList.remove('bread-order-row--selected');
      updateFooter();
    }
  };

  // Returns true if product is available for the selected date.
  const renderBadge = (container, data, date) => {
    const label = resolveDateLabel(resolveDate(date));
    const isToday = label === 'today';
    const isTomorrow = label === 'tomorrow';

    if (isToday || isTomorrow) {
      const avail      = isToday ? data.is_available_today    : data.is_available_tomorrow;
      const availOther = isToday ? data.is_available_tomorrow : data.is_available_today;
      const dayLabel   = isToday ? 'today'    : 'tomorrow';
      const otherLabel = isToday ? 'tomorrow' : 'today';

      if (avail) {
        container.innerHTML =
          `<span class="alert alert--unstyled alert--circle alert--success">Available ${dayLabel}</span>`;
        return true;
      }
      if (availOther) {
        container.innerHTML =
          `<span class="alert alert--unstyled alert--circle alert--warning">Sold out ${dayLabel}</span>` +
          `<button type="button" class="bread-order-reserve-btn" data-switch-date="${otherLabel}">` +
          `Reserve for ${otherLabel}</button>`;
        return false;
      }
      container.innerHTML =
        `<span class="alert alert--unstyled alert--circle alert--warning">Sold out</span>`;
      return false;
    }

    // Specific ISO date
    const available = data.available && (data.available_quantity ?? 0) > 0;
    container.innerHTML = available
      ? `<span class="alert alert--unstyled alert--circle alert--success">Available</span>`
      : `<span class="alert alert--unstyled alert--circle alert--warning">Sold out</span>`;
    return available;
  };

  // ── Availability check ────────────────────────────────────────────────────────

  const checkAllAvailability = async () => {
    const config = loadConfig();
    const rows = getRows();

    // Disable everything while checking
    rows.forEach((row) => {
      row.querySelector('[data-js-qty-plus]').disabled = true;
      row.querySelector('[data-js-qty-minus]').disabled = true;
      row.querySelector('[data-js-availability]').innerHTML = '';
    });

    if (!config || !config.locationId || !config.date) {
      // No delivery config set — enable all rows so user can still add to cart
      rows.forEach((row) => {
        row.querySelector('[data-js-qty-plus]').disabled = false;
      });
      return;
    }

    const filter = window._sharedInventoryFilter
      || (window._sharedInventoryFilter = new window.InventoryFilter());
    const dateIso = resolveDate(config.date);

    // One request per product, then the same answer is painted on every row that
    // shows it — a spotlight item listed twice must not be asked for twice.
    await Promise.all(uniqueRows().map(async (row) => {
      const twins = twinRows(row);

      if (row.hasAttribute('data-skip-availability')) {
        twins.forEach((twin) => setRowEnabled(twin, true));
        return;
      }

      const productId = parseInt(row.dataset.productId, 10);
      try {
        const data = await filter.getProductAvailability(productId, config.locationId, dateIso);
        twins.forEach((twin) => {
          const available = renderBadge(twin.querySelector('[data-js-availability]'), data, config.date);
          setRowEnabled(twin, available);
        });
      } catch (_) {
        twins.forEach((twin) => setRowEnabled(twin, true)); // fail-open
      }
    }));

    updateFooter();
    restoreSelection();
  };

  // ── "Reserve for tomorrow/today" flow ────────────────────────────────────────

  const switchDeliveryDate = async (dateLabel) => {
    let cartItemCount = 0;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      cartItemCount = cart.item_count || 0;
    } catch (_) {}

    if (cartItemCount > 0) {
      const confirmed = await requestCartClearConfirmation(cartItemCount);
      if (!confirmed) return;
      await fetch('/cart/clear.js', { method: 'POST' });
    }

    const isPreOrder = dateLabel !== 'today';
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { delivery_date: dateLabel === 'today' ? toMiamiDate(0) : toMiamiDate(1), pre_order_reason: isPreOrder ? 'sold_out' : '' } }),
    });

    try {
      const config = JSON.parse(localStorage.getItem('domaselo_delivery_config')) || {};
      config.date = dateLabel === 'today' ? toMiamiDate(0) : toMiamiDate(1);
      localStorage.setItem('domaselo_delivery_config', JSON.stringify(config));
      document.dispatchEvent(new CustomEvent('deliveryConfigSaved', { detail: config, bubbles: true }));
    } catch (_) {}

    window.location.reload();
  };

  // Delegate reserve-button clicks (injected dynamically by renderBadge)
  form.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-switch-date]');
    if (btn) switchDeliveryDate(btn.dataset.switchDate);
  });

  // ── Quantity stepper ──────────────────────────────────────────────────────────

  const bindQtyButtons = (row) => {
    const minus = row.querySelector('[data-js-qty-minus]');
    const plus  = row.querySelector('[data-js-qty-plus]');

    plus.addEventListener('click', () => {
      setQty(row, getQty(row) + 1);
      updateFooter();
      saveSelection();
    });

    minus.addEventListener('click', () => {
      const val = getQty(row);
      setQty(row, val <= 1 ? 0 : val - 1);
      updateFooter();
      saveSelection();
    });
  };

  // ── Variant pill buttons ──────────────────────────────────────────────────────

  // Applies a variant to one row, wherever that row lives.
  const applyVariant = (row, variantId) => {
    const pills = [...row.querySelectorAll('.variant-pill')];
    const pill = pills.find((p) => p.dataset.variantId === variantId);
    if (!pill) return;
    pills.forEach((p) => p.classList.remove('variant-pill--active'));
    pill.classList.add('variant-pill--active');
    row.dataset.variantId = pill.dataset.variantId;
    row.dataset.variantPrice = pill.dataset.price;
    const priceEl = row.querySelector('[data-js-price]');
    if (priceEl) priceEl.textContent = pill.dataset.priceFormatted;
  };

  const bindVariantSelect = (row) => {
    const pillsContainer = row.querySelector('[data-js-variant-pills]');
    if (!pillsContainer) return;

    const pills = [...pillsContainer.querySelectorAll('.variant-pill')];

    // Sync initial state from the first active pill
    const initialActive = pillsContainer.querySelector('.variant-pill--active');
    if (initialActive) {
      row.dataset.variantId = initialActive.dataset.variantId;
      row.dataset.variantPrice = initialActive.dataset.price;
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        twinRows(row).forEach((twin) => applyVariant(twin, pill.dataset.variantId));
        updateFooter();
        saveSelection();
      });
    });
  };

  // ── Bulk add to cart ──────────────────────────────────────────────────────────

  addAllBtn.addEventListener('click', async () => {
    const items = [];
    uniqueRows().forEach((row) => {
      const qty = getQty(row);
      if (qty > 0) {
        items.push({ id: parseInt(row.dataset.variantId, 10), quantity: qty });
      }
    });
    if (items.length === 0) return;

    const btnText = addAllBtn.querySelector('.button__text');
    addAllBtn.disabled = true;
    btnText.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('Cart add failed');
      clearSelection();
      if (window.refreshCart) {
        window.refreshCart();
      } else {
        window.location.href = '/cart';
      }
      setTimeout(() => {
        getRows().forEach((row) => {
          const input = row.querySelector('[data-js-qty-input]');
          const minus = row.querySelector('[data-js-qty-minus]');
          input.value = '0';
          minus.disabled = true;
          row.classList.remove('bread-order-row--selected');
        });
        updateFooter();
        addAllBtn.disabled = false;
        btnText.textContent = 'Add to Cart';
      }, 400);
    } catch (err) {
      console.error(err);
      addAllBtn.disabled = false;
      btnText.textContent = 'Add to Cart';
      // eslint-disable-next-line no-alert
      alert('Something went wrong adding items to the cart. Please try again.');
    }
  });

  // ── Init ─────────────────────────────────────────────────────────────────────

  // Move footer to <body> so position:fixed is relative to the viewport,
  // not a transformed ancestor (theme uses CSS transforms for mobile nav).
  if (footer && footer.parentElement !== document.body) {
    document.body.appendChild(footer);
  }
  if (footer) footer.style.display = 'none';

  getRows().forEach((row) => {
    bindQtyButtons(row);
    bindVariantSelect(row);
  });

  waitForFilter(checkAllAvailability);
  document.addEventListener('deliveryConfigSaved', () => waitForFilter(checkAllAvailability));

  // ── Product description toggle ────────────────────────────────────────────

  const closeAllDescriptions = () => {
    form.querySelectorAll('[data-js-description]').forEach((p) => { p.hidden = true; });
    form.querySelectorAll('[data-js-info-trigger]').forEach((t) => { t.setAttribute('aria-expanded', 'false'); });
  };

  form.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-js-info-trigger]');
    if (!trigger) return;

    e.preventDefault();

    const row = trigger.closest('[data-js-order-row]');
    const panel = row && row.querySelector('[data-js-description]');
    if (!panel) return;

    const isOpen = !panel.hidden;
    closeAllDescriptions();

    if (!isOpen) {
      panel.hidden = false;
      row.querySelectorAll('[data-js-info-trigger]').forEach((t) => t.setAttribute('aria-expanded', 'true'));
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-js-order-row]')) closeAllDescriptions();
  });
})();
